import { render } from "./BiomaterialSpecificationWindow.vue?vue&type=template&id=5a8ae71c"
import script from "./BiomaterialSpecificationWindow.vue?vue&type=script&lang=js"
export * from "./BiomaterialSpecificationWindow.vue?vue&type=script&lang=js"

import "./BiomaterialSpecificationWindow.vue?vue&type=style&index=0&id=5a8ae71c&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__